module.exports = __webpack_public_path__ + "img/youtube.958a010b.svg";